export default __webpack_public_path__ + "static/media/black_queen.91ead60b.png";